import {API_DRIVER} from "../config/axios";
import {TicketStatus} from "../component/client-panel/vouchers/vouchers-filter/VouchersFilterHelper";

export interface ITicketCreate {
    wish_id: string
    ticket_count: number
    recipient_email?: string
    recipient_name?: string
    personal_message?: string
}

export interface IUnreserveVouchers {
    order_id: string
}

const getTicketsRequestUrl = (endpointUrl: string) => {
    return `/api/tickets${endpointUrl}`
}

const TicketService = {
    obtainEntries: (body: ITicketCreate) => {
        return API_DRIVER.post(getTicketsRequestUrl(`/obtain-entries`), body)
    },
    unreserveVouchers: (body: IUnreserveVouchers) => {
        return API_DRIVER.put(getTicketsRequestUrl(`/unreserve`), body)
    },
    fetchTicketsForUser: (wishId: string) => {
        return API_DRIVER.get(getTicketsRequestUrl(`/wish/${wishId}`))
    },
    fetchTicketsForWish: (wishId: string) => {
        return API_DRIVER.get(getTicketsRequestUrl(`/wish/${wishId}/random`))
    },
    fetchClientWishTickets: (wishId: string, params: {
        limit: number
        offset: number
        search_text?: string
        status?: TicketStatus
    }) => {
        return API_DRIVER.get(getTicketsRequestUrl(`/wish/${wishId}/client`), {
            params
        })
    },
}

export default TicketService
